import React from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { H5, Btn } from '../../../AbstractElements';
import { Create, UpcomingScheduleTitle } from '../../../Constant';
import { ScheduleListData } from '../../../Data/OnlineCourse';
import ScheduleListBox from './ScheduleListBox';

const UpcomingSchedule = ({ title = UpcomingScheduleTitle, data = ScheduleListData }) => {
  return (
    <Card className='schedule-card'>
      <CardHeader className='card-no-border'>
        <div className='header-top'>
          <H5 attrH5={{ className: 'm-0' }}>{title}</H5>
        </div> 
      </CardHeader>
      <CardBody className='pt-0'>
        <ScheduleListBox data={data} />
      </CardBody>
    </Card>
  );
};

export default UpcomingSchedule;
